"use strict";
/**
 * 老路由兼容配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * clientApp/config/adpter.json
 */
var mappings_adpter = {
    "/center/gridlist.html#options_sc_all": "/center/gridlist.html#options_163_1",
    "/center/gridlist.html#options_sugar_all": "/center/gridlist.html#options_141_1",
    "/center/gridlist.html#options_cf_all": "/center/gridlist.html#options_141_2",
    "/center/gridlist.html#options_cf_ta": "/center/gridlist.html#options_141_4",
    "/center/gridlist.html#options_cf_ma": "/center/gridlist.html#options_141_3",
    "/center/gridlist.html#options_cf_cp": "/center/gridlist.html#options_141_5",
    "/center/gridlist.html#options_cf_oi": "/center/gridlist.html#options_141_7",
    "/center/gridlist.html#options_cf_pk": "/center/gridlist.html#options_141_8",
    "/center/gridlist.html#options_cf_px": "/center/gridlist.html#options_141_9",
    "/center/gridlist.html#options_cf_sh": "/center/gridlist.html#options_141_10",
    "/center/gridlist.html#options_cf_sf": "/center/gridlist.html#options_141_11",
    "/center/gridlist.html#options_cf_sm": "/center/gridlist.html#options_141_12",
    "/center/gridlist.html#options_cf_ap": "/center/gridlist.html#options_141_13",
    "/center/gridlist.html#options_cf_ur": "/center/gridlist.html#options_141_14",
    "/center/gridlist.html#options_cf_sa": "/center/gridlist.html#options_141_15",
    "/center/gridlist.html#options_cf_pf": "/center/gridlist.html#options_141_16",
    "/center/gridlist.html#options_cf_fg": "/center/gridlist.html#options_141_17",
    "/center/gridlist.html#options_cf_cj": "/center/gridlist.html#options_141_18",
    "/center/gridlist.html#options_beanpulp_all": "/center/gridlist.html#options_140_1",
    "/center/gridlist.html#options_c_all": "/center/gridlist.html#options_140_2",
    "/center/gridlist.html#options_t_all": "/center/gridlist.html#options_140_3",
    "/center/gridlist.html#options_lpg_all": "/center/gridlist.html#options_140_4",
    "/center/gridlist.html#options_pp_all": "/center/gridlist.html#options_140_5",
    "/center/gridlist.html#options_pvc_all": "/center/gridlist.html#options_140_6",
    "/center/gridlist.html#options_pe_all": "/center/gridlist.html#options_140_7",
    "/center/gridlist.html#options_p_all": "/center/gridlist.html#options_140_8",
    "/center/gridlist.html#options_a_all": "/center/gridlist.html#options_140_9",
    "/center/gridlist.html#options_b_all": "/center/gridlist.html#options_140_10",
    "/center/gridlist.html#options_y_all": "/center/gridlist.html#options_140_11",
    "/center/gridlist.html#options_eg_all": "/center/gridlist.html#options_140_12",
    "/center/gridlist.html#options_eb_all": "/center/gridlist.html#options_140_13",
    "/center/gridlist.html#options_jd_all": "/center/gridlist.html#options_140_14",
    "/center/gridlist.html#options_cs_all": "/center/gridlist.html#options_140_15",
    "/center/gridlist.html#options_lh_all": "/center/gridlist.html#options_140_16",
    "/center/gridlist.html#options_lg_all": "/center/gridlist.html#options_140_16",
    "/center/gridlist.html#options_cu_all": "/center/gridlist.html#options_151_1",
    "/center/gridlist.html#options_ru_all": "/center/gridlist.html#options_151_2",
    "/center/gridlist.html#options_au_all": "/center/gridlist.html#options_151_3",
    "/center/gridlist.html#options_al_all": "/center/gridlist.html#options_151_4",
    "/center/gridlist.html#options_zn_all": "/center/gridlist.html#options_151_5",
    "/center/gridlist.html#options_rb_all": "/center/gridlist.html#options_151_6",
    "/center/gridlist.html#options_ag_all": "/center/gridlist.html#options_151_7",
    "/center/gridlist.html#options_br_all": "/center/gridlist.html#options_151_8",
    "/center/gridlist.html#options_pb_all": "/center/gridlist.html#options_151_9",
    "/center/gridlist.html#options_ni_all": "/center/gridlist.html#options_151_10",
    "/center/gridlist.html#options_sn_all": "/center/gridlist.html#options_151_11",
    "/center/gridlist.html#options_ao_all": "/center/gridlist.html#options_151_12",
    "/center/paihang.html#paihang_0_0": "/center/gridlist.html#hs_a_board",
    "/center/list.html#10_0_0_u": "/center/gridlist.html?st=ChangePercent#sh_a_board",
    "/center/list.html#10_0_0_d": "/center/gridlist.html?st=ChangePercent&sr=1#sh_a_board",
    "/center/list.html#20_0_0_u": "/center/gridlist.html?st=ChangePercent#sz_a_board",
    "/center/list.html#20_0_0_d": "/center/gridlist.html?st=ChangePercent&sr=1#sz_a_board",
    "/center/list.html#11_0_0_u": "/center/gridlist.html?st=ChangePercent#b_board",
    "/center/list.html#11_0_0_d": "/center/gridlist.html?st=ChangePercent&sr=1#b_board",
    "/center/list.html#21_0_0_u": "/center/gridlist.html?st=ChangePercent#b_board",
    "/center/list.html#21_0_0_d": "/center/gridlist.html?st=ChangePercent&sr=1#b_board",
    "/center/bklist.html#notion_0_0": "/center/gridlist.html?st=ChangePercent#concept_board",
    "/center/bklist.html#area_0_0": "/center/gridlist.html?st=ChangePercent#region_board",
    "/center/bklist.html#trade_0_0": "/center/gridlist.html?st=ChangePercent#industry_board",
    "/center/list.html#33": "/center/gridlist.html#hs_a_board",
    "/center/list.html#10": "/center/gridlist.html#sh_a_board",
    "/center/list.html#11": "/center/gridlist.html#b_board",
    "/center/list.html#20": "/center/gridlist.html#sz_a_board",
    "/center/list.html#21": "/center/gridlist.html#b_board",
    "/center/list.html#absh_0_4": "/center/gridlist.html#ab_comparison_sh",
    "/center/list.html#absz_0_4": "/center/gridlist.html#ab_comparison_sz",
    "/center/index.html#zyzs_0_1": "/centerv2/hszs",
    "/center/list.html#15_0_1": "/center/gridlist.html#index_sh",
    "/center/list.html#25_0_1": "/center/gridlist.html#index_sz",
    "/center/list.html#35_0_1": "/center/gridlist.html#index_components",
    "/center/bankuai.html#_0_2": "/centerv2/hsbk",
    "/center/list.html#27": "/center/gridlist.html#gem_board",
    "/center/list.html#28": "/center/gridlist.html#kcb_board",
    "/center/list.html#26": "/center/gridlist.html#sme_board",
    "/center/list.html#285001_0": "/center/gridlist.html#newshares",
    "/center/list.html#28003707_12_2": "/center/gridlist.html#sh_hk_board",
    "/center/list.html#28013804_12_3": "/center/gridlist.html#sz_hk_board",
    "/center/list.html#2850022_0": "/center/gridlist.html#st_board",
    "/center/list.html#40_0_3": "/center/gridlist.html#staq_net_board",
    "/center/list.html#43_9": "/center/gridlist.html#neeq_stocks",
    "/center/list.html#44_9": "/center/gridlist.html#neeq_innovate",
    "/center/list.html#45_9": "/center/gridlist.html#neeq_basic",
    "/center/list.html#46_9": "/center/gridlist.html#neeq_agreement",
    "/center/list.html#47_9": "/center/gridlist.html#neeq_marketmaking",
    "/center/list.html#48_9": "/center/gridlist.html#neeq_bidding",
    "/center/qiquan.html#1,1,0_13_0": "/center/gridlist.html#options_sh50etf_all",
    "/center/qiquan.html#1,1,0_13_1": "/center/gridlist.html#options_sh50etf_call",
    "/center/qiquan.html#1,1,0_13_2": "/center/gridlist.html#options_sh50etf_put",
    "/center/qiquan.html#1,510050,0_13_0": "/center/gridlist.html#options_sh50etf_all",
    "/center/qiquan.html#1,510050,0_13_1": "/center/gridlist.html#options_sh50etf_call",
    "/center/qiquan.html#1,510050,0_13_2": "/center/gridlist.html#options_sh50etf_put",
    "/center/dssqiquan.html#hk_13_2": "/center/gridlist.html#options_beanpulp_all",
    "/center/zssqiquan.html#hk_13_3": "/center/gridlist.html#options_sugar_all",
    "/center/hkqiquan.html#hk_13_1": "/center/gridlist.html#options_uscny_all",
    "/center/hgtstock.html#_12": "/center/hsgt.html",
    "/center/hgtstock.html#12": "/center/hsgt.html",
    "/center/list.html#mk0144_12": "/center/gridlist.html#hk_sh_stocks",
    "/center/list.html#mk0146_12": "/center/gridlist.html#hk_sz_stocks",
    "/center/list.html#ah_12": "/center/gridlist.html#ah_comparison",
    "/center/hkstock.html#_1": "/centerv2/ggsc",
    "/center/list.html#50_1": "/center/gridlist.html#hk_stocks",
    "/center/list.html#28hsci_1": "/center/gridlist.html#hk_bluechips",
    "/center/list.html#28hscci_1": "/center/gridlist.html#hk_redchips",
    "/center/list.html#28hsciindex_1": "/center/gridlist.html#hk_redchips_components",
    "/center/list.html#28hscei_1": "/center/gridlist.html#hk_stateowned",
    "/center/list.html#28hsceiindex_1": "/center/gridlist.html#hk_stateowned_components",
    "/center/list.html#28gem_1": "/center/gridlist.html#hk_gem",
    "/center/list.html#mk0141_1": "/center/gridlist.html#hsi_large_components",
    "/center/list.html#mk0142_1": "/center/gridlist.html#hsi_medium_components",
    "/center/list.html#mk0144_1": "/center/gridlist.html#hk_components",
    "/center/list.html#52_1": "/center/gridlist.html#hk_warrants",
    "/center/list.html#32_1": "/center/gridlist.html#hk_index",
    "/center/list.html#ah_1": "/center/gridlist.html#ah_comparison",
    "/center/adrlist.html#adr_1": "/center/gridlist.html#hk_adr",
    "/center/list.html#zsqh_1": "/centerv2/qhsc/gjs/zsqh",
    "/center/list.html#yspgpqh_1": "/centerv2/qhsc/gjs/gpqh",
    "/center/list.html#hjqh_1": "/center/gridlist.html#hk_gold_futures",
    "/center/hkysp.html?code=hcf_cus#yspgpqh_1_0": "/centerv2/qhsc/gjs/HCF_CUS",
    "/center/hkysp.html?code=hcf_ucn#yspgpqh1_1_0": "/centerv2/qhsc/gjs/HCF_UCN",
    "/center/hkysp.html?code=hcf_cjp#yspgpqh2_1_0": "/centerv2/qhsc/gjs/HCF_CJP",
    "/center/hkysp.html?code=hcf_ceu#yspgpqh3_1_0": "/centerv2/qhsc/gjs/HCF_CEU",
    "/center/hkysp.html?code=hcf_cau#yspgpqh4_1_0": "/centerv2/qhsc/gjs/HCF_CAU",
    "/center/hkysp.html?code=hmfs_lrp#yspgpqh0_1_1": "/centerv2/qhsc/gjs/HMFS_LRP",
    "/center/hkysp.html?code=hmfs_lrc#yspgpqh1_1_1": "/centerv2/qhsc/gjs/HMFS_LRC",
    "/center/hkysp.html?code=hmfs_lrs#yspgpqh2_1_1": "/centerv2/qhsc/gjs/HMFS_LRS",
    "/center/hkysp.html?code=hmfs_lra#yspgpqh3_1_1": "/centerv2/qhsc/gjs/HMFS_LRA",
    "/center/hkysp.html?code=hmfs_lrz#yspgpqh4_1_1": "/centerv2/qhsc/gjs/HMFS_LRZ",
    "/center/hkysp.html?code=hmfs_lrn#yspgpqh5_1_1": "/centerv2/qhsc/gjs/HMFS_LRN",
    "/center/hkysp.html?code=hmfs_fem#yspgpqh6_1_1": "/centerv2/qhsc/gjs/HMFS_FEM",
    "/center/hkysp.html?code=hmfs_feq#yspgpqh7_1_1": "/centerv2/qhsc/gjs/HMFS_FEQ",
    "/center/usstock.html#_2": "/centerv2/mgsc",
    "/center/list.html#70_2": "/center/gridlist.html#us_stocks",
    "/center/list.html#28mk0001_2": "/center/gridlist.html#us_wellknown",
    "/center/list.html#28china_2": "/center/gridlist.html#us_chinese",
    "/center/list.html#28chinainternet_2": "/center/gridlist.html#us_chinese_internet",
    "/center/list.html#286_2": "/center/gridlist.html#us_technology",
    "/center/list.html#283_2": "/center/gridlist.html#us_financial",
    "/center/list.html#287_2": "/center/gridlist.html#us_medicine_food",
    "/center/list.html#284_2": "/center/gridlist.html#us_media",
    "/center/list.html#281_2": "/center/gridlist.html#us_automotive_energy",
    "/center/list.html#285_2": "/center/gridlist.html#us_manufacture_retail",
    "/center/global.html#global_3": "/centerv2/qqzs",
    "/center/asia.html#asia_3": "/center/gridlist.html#global_asia",
    "/center/australia.html#australia_3": "/center/gridlist.html#global_australia",
    "/center/america.html#america_3": "/center/gridlist.html#global_america",
    "/center/europe.html#europe_3": "/center/gridlist.html#global_euro",
    "/center/fund.html#_4": "/centerv2/jjsc",
    "/center/list.html#285002_4": "/center/gridlist.html#fund_close_end",
    "/center/list.html#2850013_4": "/center/gridlist.html#fund_etf",
    "/center/list.html#2850014_4": "/center/gridlist.html#fund_lof",
    "/center/fundlist.html#0,0_4_0": "http://fund.eastmoney.com/data/fundranking.html",
    "/center/fundlist.html#0,1_4_0": "http://fund.eastmoney.com/data/fundranking.html#tgp",
    "/center/fundlist.html#0,2_4_0": "http://fund.eastmoney.com/data/fundranking.html#thh",
    "/center/fundlist.html#0,3_4_0": "http://fund.eastmoney.com/data/fundranking.html#tzq",
    "/center/fundlist.html#0,4_4_0": "http://fund.eastmoney.com/data/fundranking.html#tlof",
    "/center/fundlist.html#0,5_4_0": "http://fund.eastmoney.com/data/fundranking.html#tzs",
    "/center/fundlist.html#0,6_4_0": "http://fund.eastmoney.com/data/fundranking.html#tqdii",
    "/center/fundlist.html#2,2_4_1": "http://fund.eastmoney.com/CXXFBS_bzdm.html",
    "/center/fundlist.html#1,0_4": "http://fund.eastmoney.com/HBJJ_dwsy.html",
    "/center/fundlist.html#3,_4": "http://fund.eastmoney.com/fund.html",
    "/center/futures.html#_5": "/centerv2/qhsc",
    "/center/futurelist.html#ine_5_5": "/center/gridlist.html#futures_ine",
    "/center/futurelist.html#ine,sc_5_5": "/center/gridlist.html#futures_ine-F_INE_SC",
    "/center/futurelist.html#11_5_0": "/center/gridlist.html#futures_shfe",
    "/center/futurelist.html#1,0,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_RB",
    "/center/futurelist.html#1,1,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_WR",
    "/center/futurelist.html#1,2,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_CU",
    "/center/futurelist.html#1,3,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_AL",
    "/center/futurelist.html#1,4,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_RU",
    "/center/futurelist.html#1,5,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_FU",
    "/center/futurelist.html#1,6,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_ZN",
    "/center/futurelist.html#1,7,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_AU",
    "/center/futurelist.html#1,8,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_PB",
    "/center/futurelist.html#1,9,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_AG",
    "/center/futurelist.html#1,10,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_BU",
    "/center/futurelist.html#1,11,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_HC",
    "/center/futurelist.html#1,12,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_NI",
    "/center/futurelist.html#1,13,1_5_0": "/center/gridlist.html#futures_shfe-F_SHFE_SN",
    "/center/futurelist.html#3_5_1": "/center/gridlist.html#futures_dce",
    "/center/futurelist.html#3,0,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_M",
    "/center/futurelist.html#3,1,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_A",
    "/center/futurelist.html#3,2,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_C",
    "/center/futurelist.html#3,3,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_B",
    "/center/futurelist.html#3,4,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_Y",
    "/center/futurelist.html#3,5,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_L",
    "/center/futurelist.html#3,6,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_P",
    "/center/futurelist.html#3,7,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_V",
    "/center/futurelist.html#3,8,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_J",
    "/center/futurelist.html#3,9,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_JM",
    "/center/futurelist.html#3,10,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_I",
    "/center/futurelist.html#3,11,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_JD",
    "/center/futurelist.html#3,12,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_BB",
    "/center/futurelist.html#3,13,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_FB",
    "/center/futurelist.html#3,14,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_PP",
    "/center/futurelist.html#3,15,2_5_1": "/center/gridlist.html#futures_dce-F_DCE_CS",
    "/center/futurelist.html#4_5_2": "/center/gridlist.html#futures_czce",
    "/center/futurelist.html#4,0,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_WT",
    "/center/futurelist.html#4,1,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_WH",
    "/center/futurelist.html#4,2,3_5_2": "/center/gridlist.html#futures_global-UF_NYBOT_CT",
    "/center/futurelist.html#4,3,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_SR",
    "/center/futurelist.html#4,4,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_TA",
    "/center/futurelist.html#4,5,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_OI",
    "/center/futurelist.html#4,6,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_ER",
    "/center/futurelist.html#4,7,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_MA",
    "/center/futurelist.html#4,8,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_FG",
    "/center/futurelist.html#4,9,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_RM",
    "/center/futurelist.html#4,10,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_RS",
    "/center/futurelist.html#4,11,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_ZC",
    "/center/futurelist.html#4,12,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_JR",
    "/center/futurelist.html#4,13,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_LR",
    "/center/futurelist.html#4,14,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_SF",
    "/center/futurelist.html#4,15,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_SM",
    "/center/futurelist.html#4,16,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_CY",
    "/center/futurelist.html#4,17,3_5_2": "/center/gridlist.html#futures_czce-F_CZCE_AP",
    "/center/list.html#12.1.1_5_3": "/center/gridlist.html#futures_cffex",
    "/center/list.html#12_5_3": "/center/gridlist.html#futures_cffex-_IF_FO",
    "/center/list.html#12.1_5_3": "/center/gridlist.html#futures_cffex-_IH_FO",
    "/center/list.html#12.2_5_3": "/center/gridlist.html#futures_cffex-_IC_FO",
    "/center/list.html#13_5_2": "/center/gridlist.html#futures_cffex-_TF_FO",
    "/center/list.html#13_5_3": "/center/gridlist.html#futures_cffex-_TF_FO",
    "/center/list.html#14_5_3": "/center/gridlist.html#futures_cffex-_T_FO",
    "/center/list.html#gjqh_5": "/center/gridlist.html#futures_global",
    "/center/list.html#gjqh_5_4": "/center/gridlist.html#futures_global",
    "/center/list.html#lme_5_4": "/center/gridlist.html#futures_global-lme",
    "/center/list.html#ipe_5_4": "/center/gridlist.html#futures_global-ipe",
    "/center/list.html#cobot_5_4": "/center/gridlist.html#futures_global-cobot",
    "/center/list.html#nybot_5_4": "/center/gridlist.html#futures_global-nybot",
    "/center/list.html#nymex_5_4": "/center/gridlist.html#futures_global-nymex",
    "/center/list.html#tocom_5_4": "/center/gridlist.html#futures_global-tocom",
    // "/center/forex.html#_6": "/centerv2/whsc",
    "/center/forex.html#_6": "/center/whsc.html",
    "/center/list.html#forex_6": "/center/gridlist.html#forex_all",
    "/center/list.html#1_6": "/center/gridlist.html#forex_basic",
    "/center/list.html#2_6": "/center/gridlist.html#forex_cross",
    "/center/list.html#rmbzjj_6": "/center/gridlist.html#forex_cny",
    "/center/list.html#rmbzjj_6_2": "/center/gridlist.html#forex_cnyc",
    "/center/list.html#rmbxj_6_2": "/center/gridlist.html#forex_cnyi",
    "/center/list.html#rmbjj_6_2": "/center/gridlist.html#forex_cnyb",
    "/center/list.html#28rmbrate_6": "/center/gridlist.html#forex_cnyi",
    "/center/list.html#28rmbrate_6_2": "/center/gridlist.html#forex_cnyi",
    "/center/list.html#rmbforex_6_2": "/center/gridlist.html#forex_cnh",
    // "/center/gold.html#_7": "/centerv2/hjsc",
    "/center/gold.html#_7": "/center/hjsc.html",
    "/center/glodlist.html#gjgjsqh_7": "/center/gridlist.html#nobalmetal_futures",
    "/center/futurelist.html#1,7,1_7": "/center/gridlist.html#gold_sh_futures",
    "/center/glodlist.html#gjgjsxh_7": "/center/gridlist.html#nobalmetal_spotgoods",
    "/center/glodlist.html#shhjxh_7": "/center/gridlist.html#gold_sh_spotgoods",
    // "/center/bond.html#_8": "/centerv2/zqsc",
    "/center/bond.html#_8": "/center/zqsc.html",
    "/center/list.html#bondindex_8": "/center/gridlist.html#bond_index",
    "/center/list.html#14.1.1_8_0": "/center/gridlist.html#bond_national_sh",
    "/center/list.html#14.2.1_8_0": "/center/gridlist.html#bond_enterprise_sh",
    "/center/list.html#14.3_8_0": "/center/gridlist.html#bond_convertible_sh",
    "/center/list.html#24.1_8_1": "/center/gridlist.html#bond_national_sz",
    "/center/list.html#24.2_8_1": "/center/gridlist.html#bond_enterprise_sz",
    "/center/list.html#24.3_8_1": "/center/gridlist.html#bond_convertible_sz",
    "/center/list.html#2850020_8": "/center/gridlist.html#bond_sh_buyback",
    "/center/list.html#2850021_8": "/center/gridlist.html#bond_sz_buyback",
    "/center/fullsrceenlist.html#bp_8": "/center/fullscreenlist.html#convertible_comparison",
    "/center/list.html#btb_10": "/center/gridlist.html#virtual_money_all",
    "/center/forexlist.html#3_6": "/center/gridlist.html#forex_exchange_icbc"
};
/**
 *\ClientApp\upgrade.js
 */
var mappings_upgrade = {
    '/centerv2': '/center',
    '/centerv2/': '/center/',
    '/centerv2/hsgg': '/center/gridlist.html#hs_a_board',
    '/centerv2/hsgg/hsag': '/center/gridlist.html#hs_a_board',
    '/centerv2/hsgg/shag': '/center/gridlist.html#sh_a_board',
    '/centerv2/hsgg/szag': '/center/gridlist.html#sz_a_board',
    '/centerv2/hsgg/xg': '/center/gridlist.html#newshares',
    '/centerv2/hsgg/zxb': '/center/gridlist.html#sme_board',
    '/centerv2/hsgg/cyb': '/center/gridlist.html#gem_board',
    '/centerv2/hsgg/kcb': '/center/gridlist.html#kcb_board',
    '/centerv2/hsgg/hgt': '/center/gridlist.html#sh_hk_board',
    '/centerv2/hsgg/sgt': '/center/gridlist.html#sz_hk_board',
    '/centerv2/hsgg/bg': '/center/gridlist.html#b_board',
    '/centerv2/hsgg/abgbj': '/center/gridlist.html#ab_comparison',
    '/centerv2/hsgg/abgbj/shabgbj': '/center/gridlist.html#ab_comparison_sh',
    '/centerv2/hsgg/abgbj/szabgbj': '/center/gridlist.html#ab_comparison_sz',
    '/centerv2/hsgg/fxjsb': '/center/gridlist.html#st_board',
    '/centerv2/hsgg/lwjts': '/center/gridlist.html#staq_net_board',
    '/centerv2/hsbk/gnbk': '/center/gridlist.html#concept_board',
    '/centerv2/hsbk/dybk': '/center/gridlist.html#region_board',
    '/centerv2/hsbk/hybk': '/center/gridlist.html#industry_board',
    '/centerv2/hszs/shxlzs': '/center/gridlist.html#index_sh',
    '/centerv2/hszs/szxlzs': '/center/gridlist.html#index_sz',
    '/centerv2/hszs/zscf': '/center/gridlist.html#index_components',
    '/centerv2/xsb': '/center/gridlist.html#neeq_stocks',
    '/centerv2/xsb/qb': '/center/gridlist.html#neeq_stocks',
    '/centerv2/xsb/cxc': '/center/gridlist.html#neeq_innovate',
    '/centerv2/xsb/jcc': '/center/gridlist.html#neeq_basic',
    '/centerv2/hsgt/hgt': '/center/gridlist.html#sh_hk_board',
    '/centerv2/hsgt/sgt': '/center/gridlist.html#sz_hk_board',
    '/centerv2/hsgt/ggth': '/center/gridlist.html#hk_sh_stocks',
    '/centerv2/hsgt/ggts': '/center/gridlist.html#hk_sz_stocks',
    '/centerv2/hsgt/ahgbj': '/center/gridlist.html#ah_comparison',
    '/centerv2/ggsc/qbgg': '/center/gridlist.html#hk_stocks',
    '/centerv2/ggsc/ggzb': '/center/gridlist.html#hk_mainboard',
    '/centerv2/ggsc/ggcyb': '/center/gridlist.html#hk_gem',
    '/centerv2/ggsc/zmgg': '/center/gridlist.html#hk_wellknown',
    '/centerv2/ggsc/lcg': '/center/gridlist.html#hk_bluechips',
    '/centerv2/ggsc/hcg': '/center/gridlist.html#hk_redchips',
    '/centerv2/ggsc/gqg': '/center/gridlist.html#hk_stateowned',
    '/centerv2/ggsc/ggcfg': '/center/gridlist.html#hk_components',
    '/centerv2/ggsc/ahgbj': '/center/gridlist.html#ah_comparison',
    '/centerv2/ggsc/xgzs': '/center/gridlist.html#hk_index',
    '/centerv2/ggsc/ggwl': '/center/gridlist.html#hk_warrants',
    '/centerv2/mgsc/qbmg': '/center/gridlist.html#us_stocks',
    '/centerv2/mgsc/zmmg': '/center/gridlist.html#us_wellknown',
    '/centerv2/mgsc/zggng': '/center/gridlist.html#us_chinese',
    '/centerv2/mgsc/mgzs': '/center/gridlist.html#us_index',
    '/centerv2/qqzs/yzgs': '/center/gridlist.html#global_asia',
    '/centerv2/qqzs/mzgs': '/center/gridlist.html#global_america',
    '/centerv2/qqzs/ozgs': '/center/gridlist.html#global_euro',
    '/centerv2/qqzs/azgs': '/center/gridlist.html#global_australia',
    '/centerv2/qhsc/sqs': '/center/gridlist.html#futures_shfe',
    '/centerv2/qhsc/sns': '/center/gridlist.html#futures_ine',
    '/centerv2/qhsc/dss': '/center/gridlist.html#futures_dce',
    '/centerv2/qhsc/zss': '/center/gridlist.html#futures_czce',
    '/centerv2/qhsc/zjs': '/center/gridlist.html#futures_cffex',
    '/centerv2/qhsc/gjs/hjqh': '/center/gridlist.html#hk_gold_futures',
    '/centerv2/qhsc/gjqh': '/center/gridlist.html#futures_global',
    '/centerv2/jjsc/fbjjhq': '/center/gridlist.html#fund_close_end',
    '/centerv2/jjsc/etfjjhq': '/center/gridlist.html#fund_etf',
    '/centerv2/jjsc/lofjjhq': '/center/gridlist.html#fund_lof',
    '/centerv2/zqsc/zqzs': '/center/gridlist.html#bond_index',
    '/centerv2/zqsc/shzq': '/center/gridlist.html#bond_sh',
    '/centerv2/zqsc/shzq/hgz': '/center/gridlist.html#bond_national_sh',
    '/centerv2/zqsc/shzq/hqz': '/center/gridlist.html#bond_enterprise_sh',
    '/centerv2/zqsc/shzq/hzz': '/center/gridlist.html#bond_convertible_sh',
    '/centerv2/zqsc/szzq': '/center/gridlist.html#bond_sz',
    '/centerv2/zqsc/szzq/sgz': '/center/gridlist.html#bond_national_sz',
    '/centerv2/zqsc/szzq/sqz': '/center/gridlist.html#bond_enterprise_sz',
    '/centerv2/zqsc/szzq/szz': '/center/gridlist.html#bond_convertible_sz',
    '/centerv2/zqsc/shhg': '/center/gridlist.html#bond_sh_buyback',
    '/centerv2/zqsc/szhg': '/center/gridlist.html#bond_index',
    '/centerv2/whsc/syhl': '/center/gridlist.html#forex_all',
    '/centerv2/whsc/jbhl': '/center/gridlist.html#forex_basic',
    '/centerv2/whsc/jchl': '/center/gridlist.html#forex_cross',
    '/centerv2/whsc/rmbpz': '/center/gridlist.html#forex_cny',
    '/centerv2/whsc/rmbpz/rmbhlzjj': '/center/gridlist.html#forex_cnyc',
    '/centerv2/whsc/rmbpz/rmbxj': '/center/gridlist.html#forex_cnyi',
    '/centerv2/whsc/rmbpz/rmbjj': '/center/gridlist.html#forex_cnyb',
    '/centerv2/whsc/rmbpz/larmbwb': '/center/gridlist.html#forex_cnh',
    '/centerv2/qqsc/sjs': '/center/gridlist.html#options_sh50etf_all',
    '/centerv2/qqsc/sjs/sh50etf': '/center/gridlist.html#options_sh50etf_all',
    '/centerv2/qqsc/dss': '/center/gridlist.html#options_beanpulp_all',
    '/centerv2/qqsc/dss/dp': '/center/gridlist.html#options_beanpulp_all',
    '/centerv2/qqsc/zss': '/center/gridlist.html#options_sugar_all',
    '/centerv2/qqsc/zss/bt': '/center/gridlist.html#options_sugar_all',
    '/centerv2/qqsc/xgqjs': '/center/gridlist.html#options_uscny_all',
    '/centerv2/qqsc/xgqjs/mydrmbqq': '/center/gridlist.html#options_uscny_all',
    '/centerv2/hjsc/shhjxh': '/center/gridlist.html#gold_sh_spotgoods',
    '/centerv2/hjsc/shhjqh': '/center/gridlist.html#gold_sh_futures',
    '/centerv2/hjsc/gjgjsxh': '/center/gridlist.html#nobalmetal_spotgoods',
    '/centerv2/hjsc/gjgjsqh': '/center/gridlist.html#nobalmetal_futures',
    // '/center/gridlist.html#futures_cffex-_T': '/center/gridlist.html#futures_220_4'
};
// 新版改造的路由
var mapping_new = {
    "/center/gjs.html#futures_hkex": "/center/gridlist.html#futures_hkex",
};
var maps = Object.assign({}, mappings_adpter, mappings_upgrade, mapping_new);
exports.default = maps;
